import { cloneElement } from 'react';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { List, ListItem } from '../../../../elements/List/List';

export interface IInterapyReportFieldProps {
    extraValueElement?: JSX.Element;
    initValue: string | undefined;
    label: string;
    remarks?: string;
    value: string | undefined;
}

export function InterapyReportField(props: IInterapyReportFieldProps) {
    if (!props.value) {
        return null;
    }

    const items: JSX.Element[] = [<ListItem bold>{props.value}</ListItem>];

    if (props.initValue && props.initValue !== props.value) {
        items.push(<ListItem>Automatisch berekende waarde: {props.initValue}</ListItem>);
    }

    if (props.remarks) {
        items.push(<ListItem>Toelichting: {props.remarks}</ListItem>);
    }

    return (
        <HorizontalFormGroupRead>
            <FormLabel>{props.label}</FormLabel>
            <InputContainer>
                <List>
                    {items.map((item, index) => {
                        return cloneElement(item, { key: index });
                    })}
                </List>
                {props.extraValueElement}
            </InputContainer>
        </HorizontalFormGroupRead>
    );
}
